import { useCallback, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/transitional/components/View';
import { Header } from 'foundations-components/transitional/components/Header';
import UITabs from 'UIComponents/nav/UITabs';
import UITab from 'UIComponents/nav/UITab';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import ListingLibTitleWithCounts from 'framework-listing-lib/elements/ListingLibTitleWithCounts';
import NonHubSpotStatus from 'FormsUI/components/dashboard/nonHubSpotStatus/NonHubSpotStatusContainerLoadable';
import FormCreationButton from 'FormsUI/components/dashboard/FormCreationButtonContainer';
import DashboardActions from 'FormsUI/components/dashboard/DashboardActions';
import { TABS } from 'FormsUI/constants/Dashboard';
import BusinessUnitTagContainer from 'FormsUI/components/common/BusinessUnitTagContainer';
import CreateFormPanel from 'FormsUI/components/dashboard/createForm/CreateFormPanel';
import { useFormCreation } from 'FormsUI/hooks/useFormCreation';
import { trackDashboardInteraction } from 'FormsUI/utils/TrackingUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const Tabs = ({
  selected,
  onChange
}) => /*#__PURE__*/_jsxs(UIFlex, {
  align: "center",
  children: [/*#__PURE__*/_jsxs(UITabs, {
    selected: selected,
    onSelectedChange: ({
      target: {
        value
      }
    }) => {
      if (value === TABS.MANAGE || value === TABS.ANALYZE) {
        onChange(value);
      }
    },
    children: [/*#__PURE__*/_jsx(UITab, {
      tabId: TABS.MANAGE,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'dashboard.tabs.manage'
      })
    }), /*#__PURE__*/_jsx(UITab, {
      tabId: TABS.ANALYZE,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'dashboard.tabs.analyze'
      })
    })]
  }), /*#__PURE__*/_jsx(View, {
    as: "span",
    marginInlineStart: "auto",
    children: /*#__PURE__*/_jsx(UIFlex, {
      children: /*#__PURE__*/_jsx(UIBox, {
        children: /*#__PURE__*/_jsx(NonHubSpotStatus, {})
      })
    })
  })]
});
const FormsDashboardHeader = ({
  tab,
  onTabChange,
  hasBusinessUnitAccess = false,
  hasFormTemplatesGate = false,
  isComparisonAllowed,
  isPortalZeroState,
  ungatedForBusinessUnitPicker = false
}) => {
  const [openSidepanel, setOpenSidepanel] = useState(false);
  const closeSidePanel = () => setOpenSidepanel(false);
  const {
    onCreateFormClick
  } = useFormCreation({
    isPortalZeroState
  });
  const onClick = useCallback(() => {
    if (hasFormTemplatesGate) {
      trackDashboardInteraction('create-form-button-click');
    }
    return onCreateFormClick();
  }, [hasFormTemplatesGate, onCreateFormClick]);
  const isManageTab = tab === TABS.MANAGE;
  const shouldShowDashboardActions = !isPortalZeroState && !isManageTab;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Header, {
      marginBlockEnd: "0",
      title: isManageTab ? /*#__PURE__*/_jsx(ListingLibTitleWithCounts, {
        title: /*#__PURE__*/_jsxs(UIFlex, {
          align: "center",
          gap: 4,
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: 'dashboard.formsHeading'
          }), hasBusinessUnitAccess && ungatedForBusinessUnitPicker && /*#__PURE__*/_jsx(BusinessUnitTagContainer, {
            onlyLogo: true
          })]
        })
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'dashboard.formsHeading'
      }),
      flush: true,
      tabs: /*#__PURE__*/_jsx(Tabs, {
        selected: tab,
        onChange: onTabChange
      }),
      children: [shouldShowDashboardActions ? /*#__PURE__*/_jsx(DashboardActions, {
        isPqlDisabled: !isComparisonAllowed
      }) : null, /*#__PURE__*/_jsx(FormCreationButton, {
        isPortalZeroState: isPortalZeroState,
        onClick: onClick
      })]
    }), openSidepanel && /*#__PURE__*/_jsx(CreateFormPanel, {
      closeSidePanel: closeSidePanel
    })]
  });
};
export default FormsDashboardHeader;